export const dataEs = {
  banner: {
    title: "Ordenamos y gobernamos los datos de tu organización",
    subTitle: "Transformamos datos dispersos en un activo gobernado y auditable, con trazabilidad end-to-end, controles claros y adopción segura en entornos regulados.",
    buttonConsult: "Habla con un especialista",
  },
  challengeToday: {
    title: "El desafío hoy",
    description: "Las organizaciones que operan en entornos altamente regulados avanzan en digitalización, automatización e inteligencia artificial, pero sus datos suelen crecer de forma fragmentada, con bajo nivel de gobierno, control y trazabilidad.\n\nEn este contexto, la información pierde confiabilidad, se multiplican los reportes aislados y las iniciativas de datos no logran sostenerse ni escalar dentro de la operación diaria.",
    cards: [
      {
        id: 1,
        icon: "database-off",
        title: "Fragmentación y silos de información",
        description: "Los datos se distribuyen entre múltiples sistemas, áreas y reportes, sin un modelo común de gestión ni ownership definido, dificultando su uso transversal.",
        iconSize: 64,
        iconStroke: 2,
      },
      {
        id: 2,
        icon: "shield-x",
        title: "Falta de gobierno y trazabilidad",
        description: "La ausencia de reglas sobre calidad, catalogación y responsabilidades impide demostrar origen, uso y confiabilidad de los datos, exponiendote a reprocesos y riesgos de cumplimiento.",
        iconSize: 64,
        iconStroke: 2,
      },
      {
        id: 3,
        icon: "currency-dollar-off",
        title: "Datos que no generan valor",
        description: "Sin productos de datos ni foco en casos de uso concretos, la analítica queda limitada a esfuerzos aislados que no impactan en la organización.",
        iconSize: 64,
        iconStroke: 2,
      },
    ],
    footer: "El desafío no es acumular datos, sino ordenarlos, gobernarlos y convertirlos en un activo confiable y utilizable en toda la empresa.",
  },
  approach: {
    title: "Cómo abordamos este desafío",
    items: [
      {
        icon: "compass",
        text: "En Possumus abordamos los datos como un habilitador estratégico, no como un problema exclusivamente técnico.",
      },
      {
        icon: "brand-windows",
        text: "Nuestro enfoque combina gobernanza moderna, arquitectura de datos sobre el ecosistema Microsoft y gestión del cambio.",
      },
      {
        icon: "user-cog",
        text: "Trabajamos de forma progresiva, adaptándonos al nivel de madurez de cada organización, para construir bases sólidas que puedan sostenerse y evolucionar en el tiempo.",
      },
    ],
  },
  governanceProgram: {
    title: "Programa de Gobernanza y Gestión de Datos",
    subtitle: "En Possumus diseñamos e implementamos programas integrales de Datos que permiten a las organizaciones construir una base sólida, gobernada y orientada al valor de negocio.",
    partners: [
      { name: "fabric", logo: "fabric" },
      { name: "powerbi", logo: "powerbi" },
      { name: "purview", logo: "purview" },
      { name: "azure", logo: "azure" },
    ],
  },
  objective: {
    title: "Objetivo",
    description: "Construir un modelo de gestión de datos claro y sostenible, que ordene la información de la organización, defina responsabilidades y transforme datos dispersos en activos confiables, utilizados y gobernados en toda la operación.",
    pills: [
      {
        icon: "calendar-event",
        text: "Programa progresivo",
      },
      {
        icon: "users",
        text: "Equipo Possumus + referentes internos",
      },
      {
        icon: "stack-2",
        text: "Dominios y productos de datos priorizados",
      },
      {
        icon: "arrow-up-right",
        text: "Delivery: on-site y remoto",
      },
    ]
  },
  activities: {
    title: "Actividades",
    cards: [
      {
        id: 1,
        title: "Gobierno de datos federado",
        description: "Definimos dominios de datos, asignamos roles de ownership (owners y stewards) y establecemos reglas de gobierno que ordenan la gestión de la información sin frenar la operación diaria de las áreas.",
      },
      {
        id: 2,
        title: "Visibilidad y confianza en los datos",
        description: "Diseñamos e implementamos prácticas de catalogación y gestión de metadatos que permiten conocer qué datos existen, dónde residen, cómo se usan y cuáles están certificados.",
      },
      {
        id: 3,
        title: "Datos organizados como productos",
        description: "Identificamos y priorizamos productos de datos alineados a necesidades reales del negocio, transformando fuentes dispersas en activos reutilizables y escalables.",
      },
      {
        id: 4,
        title: "Adopción, autoservicio y cultura de datos",
        description: "Acompañamos a los equipos con lineamientos, estándares y capacitación para que los datos se comprendan, se utilicen correctamente y se sostengan en el tiempo.",
      },
    ],
  },
  expectedResults: {
    title: "Resultados esperados",
    description: "Al finalizar el programa, la organización pasa de un escenario de datos fragmentados e iniciativas aisladas a un modelo estructurado y gobernado, con reglas claras, visibilidad sobre sus activos de datos y capacidades internas para sostener su evolución.",
    cards: [
      {
        id: 1,
        icon: "hierarchy-2",
        title: "Gobierno de datos definido y operativo",
        description: "Dominios de datos formalizados, roles de ownership claros y un modelo de gobierno respaldado por artefactos como mapas de dominios, matrices RACI y lineamientos operativos.",
      },
      {
        id: 2,
        icon: "eye-check",
        title: "Visibilidad y trazabilidad de los datos",
        description: "Catálogo corporativo operativo, glosario de negocio y metadatos que permiten identificar orígenes, responsables, relaciones y nivel de confiabilidad de los datos utilizados.",
      },
      {
        id: 3,
        icon: "box-multiple",
        title: "Productos de datos listos para escalar",
        description: "Portafolio inicial de productos de datos priorizados por impacto y viabilidad, alineados a necesidades concretas del negocio.",
      },
      {
        id: 4,
        icon: "users-group",
        title: "Capacidades internas y autoservicio gobernado",
        description: "Estándares de autoservicio, plantillas y prácticas compartidas que fortalecen la cultura de datos y reducen la dependencia de equipos centrales o proveedores externos.",
      },
    ],
  },
  useCases: {
    title: "Casos de uso en:",
    cards: [
      {
        id: 1,
        logo: "capex",
      },
      {
        id: 2,
        logo: "tassaroli",
      },
      {
        id: 3,
        logo: "veritran",
      },
    ],
  },
  ctaBanner: {
    title: "Ordená tus datos. Gobernalos. Convertí la información en un activo real para tu organización.",
    buttonText: "Conversemos",
    quote: "Acompañá tu estrategia con equipos especializados que trabajan dentro de tu organización para acelerar resultados y fortalecer tu ventaja competitiva.",
  },
  whyPossumus: {
    title: "Por qué las empresas eligen Possumus",
    cards: [
      {
        id: 1,
        icon: "trophy",
        title: "Top 5 de partners de Microsoft en Argentina, certificados en las seis designaciones de Microsoft.",
        iconSize: 64,
        iconStroke: 1.5,
      },
      {
        id: 2,
        icon: "database-cog",
        title: "Especialistas en Microsoft Fabric, Power BI, Purview y Azure.",
        iconSize: 64,
        iconStroke: 1.5
      },
      {
        id: 3,
        icon: "shield-check",
        iconSize: 64,
        iconStroke: 1.5,
        title: "Enfoque seguro y responsable, alineado con los principios de IA Responsable de Microsoft.",
      },
      {
        id: 4,
        icon: "certificate-2",
        iconSize: 64,
        iconStroke: 1.5,
        title: "Metodología acreditada ISO 9001:2015, que garantiza calidad y trazabilidad.",
      },
      {
        id: 5,
        icon: "heart-handshake",
        title: "Acompañamiento humano y técnico hasta lograr adopción real: no desplegamos, hacemos que funcione.",
        iconSize: 64,
        iconStroke: 1.5,
      }
    ],
  },
  microsoftPartner: {
    title: "Somos Top Partner de Microsoft en Argentina",
    description: "designaciones",
  },
  softwareSection: {
    title: "¿Listo para contratar tu software?",
    subtitle: "Proceso simple y transparente",
    steps: [
      {
        id: 1,
        title: "1. Discovery call",
        description: "Conversamos sobre tus desafíos y objetivos de datos en una sesión de 30 minutos.",
      },
      {
        id: 2,
        title: "2. Propuesta personalizada",
        description: "Diseñamos una solución a medida con roadmap, equipo y pricing claro.",
      },
      {
        id: 3,
        title: "3. Kick-off rápido",
        description: "Arrancamos en menos de 2 semanas con tu equipo dedicado de data governance.",
      },
    ],
  },
  contact: {
    title: "Diseño de contacto",
    subtitle: "Hablemos de tus datos",
  },
};

export const dataEn = {
  banner: {
    title: "We organize and govern your organization's data",
    subTitle: "We turn fragmented data into a governed and auditable asset, with end-to-end traceability, clear controls, and secure adoption in regulated environments.",
    buttonConsult: "Talk to a specialist",
  },
  challengeToday: {
    title: "Today's challenge",
    description: "Organizations operating in highly regulated environments continue to advance in digitalization, automation, and artificial intelligence. However, their data often grows fragmented, with limited governance, control, and traceability.\n\nIn this context, data loses reliability, isolated reports proliferate, and data initiatives struggle to scale or sustain themselves as part of day-to-day operations.",
    cards: [
      {
        id: 1,
        icon: "database-off",
        title: "Fragmentation and data silos",
        description: "Data is spread across multiple systems, teams, and reports, without a shared management model or clearly defined ownership, limiting its cross-functional use.",
        iconSize: 64,
        iconStroke: 2,
      },
      {
        id: 2,
        icon: "shield-x",
        title: "Lack of governance and traceability",
        description: "The absence of clear rules around data quality, cataloging, and accountability makes it difficult to demonstrate data origin, usage, and reliability, exposing the organization to rework and compliance risks.",
        iconSize: 64,
        iconStroke: 2,
      },
      {
        id: 3,
        icon: "currency-dollar-off",
        title: "Data that does not create value",
        description: "Without data products or a clear focus on concrete use cases, analytics remains limited to isolated efforts that fail to generate organizational impact.",
        iconSize: 64,
        iconStroke: 2,
      },
    ],
    footer: "The real challenge is not collecting more data, but organizing it, governing it, and turning it into a reliable and usable asset across the enterprise.",
  },
  approach: {
    title: "How we address this challenge",
    items: [
      {
        icon: "compass",
        text: "At Possumus, we treat data as a strategic enabler, not merely a technical problem.",
      },
      {
        icon: "brand-windows",
        text: "Our approach combines modern data governance, Microsoft-based data architecture, and change management.",
      },
      {
        icon: "user-cog",
        text: "We work progressively, adapting to each organization's maturity level, to build solid foundations that can be sustained and evolve over time.",
      },
    ],
  },
  governanceProgram: {
    title: "Data Governance and Management Program",
    subtitle: "At Possumus, we design and implement comprehensive data programs that enable organizations to build a solid, governed foundation focused on business value.",
    partners: [
      { name: "fabric", logo: "fabric" },
      { name: "powerbi", logo: "powerbi" },
      { name: "purview", logo: "purview" },
      { name: "azure", logo: "azure" },
    ],
  },
  objective: {
    title: "Objective",
    description: "To build a clear and sustainable data management model that organizes enterprise information, defines responsibilities, and transforms fragmented data into trusted, governed assets used across the organization.",
    pills: [
      {
        icon: "calendar-event",
        text: "Progressive program",
      },
      {
        icon: "users",
        text: "Possumus team + internal stakeholders",
      },
      {
        icon: "stack-2",
        text: "Prioritized data domains and data products",
      },
      {
        icon: "arrow-up-right",
        text: "Delivery: on-site and remote",
      },
    ]
  },
  activities: {
    title: "Activities",
    cards: [
      {
        id: 1,
        title: "Federated data governance",
        description: "We define data domains, assign ownership roles (data owners and stewards), and establish governance rules that structure information management without disrupting day-to-day operations.",
      },
      {
        id: 2,
        title: "Data visibility and trust",
        description: "We design and implement cataloging and metadata management practices that provide visibility into what data exists, where it resides, how it is used, and which datasets are certified.",
      },
      {
        id: 3,
        title: "Data organized as business products",
        description: "We identify and prioritize data products aligned with real business needs, transforming dispersed sources into reusable and scalable assets.",
      },
      {
        id: 4,
        title: "Adoption, self-service, and data culture",
        description: "We support teams with guidelines, standards, and training so data is properly understood, correctly used, and sustainably maintained over time.",
      },
    ],
  },
  expectedResults: {
    title: "Expected Results",
    description: "By the end of the program, organizations move from fragmented data and isolated initiatives to a structured, governed model with clear rules, full visibility into data assets, and internal capabilities to sustain continuous evolution.",
    cards: [
      {
        id: 1,
        icon: "hierarchy-2",
        title: "Defined and operational data governance",
        description: "Formalized data domains, clearly assigned ownership roles, and a governance model supported by artifacts such as domain maps, RACI matrices, and operational guidelines.",
      },
      {
        id: 2,
        icon: "eye-check",
        title: "Data visibility and traceability",
        description: "An operational enterprise data catalog, business glossary, and metadata that enable identification of data sources, ownership, relationships, and trust levels.",
      },
      {
        id: 3,
        icon: "box-multiple",
        title: "Data products ready to scale",
        description: "An initial portfolio of data products prioritized by business impact and feasibility, aligned with concrete business needs.",
      },
      {
        id: 4,
        icon: "users-group",
        title: "Internal capabilities and governed self-service",
        description: "Self-service standards, templates, and shared practices that strengthen data culture and reduce dependency on central teams or external providers.",
      },
    ],
  },
  useCases: {
    title: "Case studies",
    cards: [
      {
        id: 1,
        logo: "capex",
      },
      {
        id: 2,
        logo: "tassaroli",
      },
      {
        id: 3,
        logo: "veritran",
      },
    ],
  },
  ctaBanner: {
    title: "Organize your data. Govern it. Turn information into a real asset for your organization.",
    buttonText: "Let's talk",
    quote: "Support your strategy with specialized teams embedded within your organization to accelerate outcomes and strengthen your competitive advantage.",
  },
  whyPossumus: {
    title: "Why companies choose Possumus",
    cards: [
      {
        id: 1,
        icon: "trophy",
        title: "Top 5 Microsoft partner in Argentina, certified across all six Microsoft Solution Partner designations.",
        iconSize: 64,
        iconStroke: 1.5,
      },
      {
        id: 2,
        icon: "database-cog",
        title: "Specialists in Microsoft Fabric, Power BI, Purview, and Azure.",
        iconSize: 64,
        iconStroke: 1.5
      },
      {
        id: 3,
        icon: "shield-check",
        iconSize: 64,
        iconStroke: 1.5,
        title: "Secure and responsible approach, aligned with Microsoft's Responsible AI principles.",
      },
      {
        id: 4,
        icon: "certificate-2",
        iconSize: 64,
        iconStroke: 1.5,
        title: "ISO 9001:2015 certified methodology, ensuring quality and traceability.",
      },
      {
        id: 5,
        icon: "heart-handshake",
        title: "Human and technical support until real adoption is achieved: we don't just deploy, we make it work.",
        iconSize: 64,
        iconStroke: 1.5,
      }
    ],
  },
  microsoftPartner: {
    title: "We're a Top Microsoft Partner across the Americas",
    description: "Designations",
  },
  softwareSection: {
    title: "Ready to build your software?",
    subtitle: "Simple and transparent process",
    steps: [
      {
        id: 1,
        title: "1. Discovery call",
        description: "We discuss your data challenges and objectives in a 30-minute session.",
      },
      {
        id: 2,
        title: "2. Custom proposal",
        description: "We design a tailored solution with a clear roadmap, team, and pricing.",
      },
      {
        id: 3,
        title: "3. Fast kick-off",
        description: "We start in less than 2 weeks with your dedicated data governance team.",
      },
    ],
  },
  contact: {
    title: "Contact design",
    subtitle: "Let's talk about your data",
  },
};
